import { render, staticRenderFns } from "./SeminarScreen.vue?vue&type=template&id=1456af7a&"
import script from "./SeminarScreen.vue?vue&type=script&lang=js&"
export * from "./SeminarScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports